import styled, {css} from "styled-components"

const UserMenuDropdownOptions = styled.div`
  ${({theme}) => css`
    position: absolute;
    right: 0;
    min-width: 190px;
    border-radius: 8px;
    background-color: white;
    box-shadow: ${theme.shadows.high};
    overflow: hidden;

    a {
      align-items: center;
      display: flex;
      padding: ${theme.spacing.one} ${theme.spacing.two};
      &:hover {
        text-decoration: none;
        background-color: ${theme.colors.greys.lightest};
      }
    }
    hr {
      width: calc(100% - ${theme.spacing.four});
      margin: ${theme.spacing.one} ${theme.spacing.two};
    }
  `}
`

export default UserMenuDropdownOptions
